export default __webpack_public_path__ + "static/media/libraries.c2fc95c0.svg";